export const DEFAULT_INPUT_FIELD_HEIGHT = 40

export const CLASS_ALIASES = {
  24: 'size24',
  32: 'size32',
  40: 'size40',
  48: 'size48',
}
